import { X } from "lucide-react";
import { useToasts } from "./toast";
import s from "./Toasts.module.css";

export function Toasts() {
  const { toasts, dismiss } = useToasts();
  if (toasts.length === 0) return null;
  return (
    <div className={s.viewport} role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={[s.toast, s[t.kind]].join(" ")}>
          <span>{t.message}</span>
          {t.action ? (
            <button
              type="button"
              className={s.action}
              onClick={() => {
                t.action!.onClick();
                dismiss(t.id);
              }}
            >
              {t.action.label}
            </button>
          ) : null}
          <button type="button" className={s.close} aria-label="Dismiss" onClick={() => dismiss(t.id)}>
            <X size={13} />
          </button>
        </div>
      ))}
    </div>
  );
}
